exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tasks-page-wrapper[data-v-43debf73] {\n    display: flex;\n    flex-direction: column;\n    padding: 0.4rem 2rem 2rem;\n}\n", ""]);

// exports
